import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import "../css/PolicyPages.css";

const AboutUs = () => {
  return (
    <>
      <Header />

      <div className="policy-hero">
        <h1>About Us</h1>
        <p>
          Learn more about Ranthambore Tours & Travel Assistance and how we help
          travelers plan their Ranthambore wildlife experience.
        </p>
      </div>

      <div className="policy-wrapper">

        {/* WHO WE ARE */}
        <div className="policy-section">
          <h2>Who We Are</h2>
          <p>
            Ranthambore Tours & Travel Assistance is a registered MSME enterprise
            based in Gurgaon, Haryana. We provide travel planning services to help
            visitors organize complete Ranthambore trips including safari experiences,
            accommodation, and local support.
          </p>

          <p>
            We are an independent travel service provider and are not affiliated with
            the Government of Rajasthan or the official forest department booking system.
          </p>
        </div>

        {/* WHAT WE DO */}
        <div className="policy-section">
          <h2>What We Do</h2>
          <p>
            Our services focus on helping travelers plan their Ranthambore visit through
            curated tour packages. We assist with travel planning, accommodation guidance,
            safari experience coordination, and overall trip support.
          </p>

          <p>
            We also provide guidance regarding safari zones, timings, reporting procedures,
            park rules, and general travel planning for Ranthambore National Park.
          </p>

          <p>
            Please note that we do not operate safari vehicles directly. Safari experiences
            are conducted by authorised operators as per forest department regulations.
          </p>
        </div>

        {/* MISSION */}
        <div className="policy-section">
          <h2>Our Mission</h2>
          <p>
            Our mission is to make Ranthambore travel simple and convenient by offering
            clear information, curated travel packages, and reliable assistance to ensure
            a smooth wildlife experience.
          </p>
        </div>

        {/* BUSINESS INFO */}
        <div className="policy-section">
          <h2>Business Information</h2>
          <p>
            <strong>Business Name (Registered):</strong> Ranthambore Safari Booking Assistance <br />
            <strong>Operating As:</strong> Ranthambore Tours & Travel Assistance <br />
            <strong>Business Type:</strong> Travel Planning & Assistance Service <br />
            <strong>Location:</strong> Gurgaon, Haryana, India <br />
            <strong>Service Area:</strong> Ranthambore National Park, Rajasthan <br />
            <strong>Phone:</strong> +91-9217691062 <br />
            <strong>Email:</strong> support@safariranthamborebooking.com
          </p>
        </div>

        {/* DISCLAIMER */}
        <div className="policy-section">
          <h2>Important Disclaimer</h2>
          <p>
            Ranthambore Tours & Travel Assistance is an independent travel service
            providing trip planning and safari experience coordination.
          </p>

          <p>
            We are not affiliated with the Forest Department or any government authority,
            and we are not an official safari booking portal.
          </p>

          <p>
            All safari experiences are subject to availability and are conducted by
            authorised operators as per park regulations.
          </p>
        </div>

      </div>

      
    </>
  );
};

export default AboutUs;